module.exports = __webpack_public_path__ + "img/chadle_adv_14.cfc112db.png";